"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAddCollectionReducer = createAddCollectionReducer;
exports.createRemoveCollectionReducer = createRemoveCollectionReducer;
exports.createTargetedRemoveCollectionReducer = createTargetedRemoveCollectionReducer;
exports.createUpdateCollectionReducer = createUpdateCollectionReducer;
exports.createTargetedUpdateCollectionReducer = createTargetedUpdateCollectionReducer;
exports.getCollectionSyncReducer = getCollectionSyncReducer;
exports.createCollectionSyncReducer = createCollectionSyncReducer;
exports.createSyncReducer = createSyncReducer;
const lib_1 = require("../actionTypes/lib.js");
const immer_1 = require("immer");
const Verbs_1 = require("../types/Verbs.js");
function createAddCollectionReducer(options) {
    return function (state = options.state, action) {
        return (0, immer_1.produce)(state, (draft) => {
            if (draft.data) {
                const added = options.add(action.data, draft.data.results);
                if (Array.isArray(added)) {
                    draft.data.results = added;
                }
                else {
                    draft.data.results.push(added);
                }
            }
        });
    };
}
function createRemoveCollectionReducer(options) {
    return function (state = options.state) {
        return (0, immer_1.produce)(state, (draft) => {
            if (draft.data) {
                draft.data.results = [];
            }
        });
    };
}
function createTargetedRemoveCollectionReducer(options) {
    return function (state = options.state, action) {
        return (0, immer_1.produce)(state, (draft) => {
            var _a;
            if (options.target && ((_a = draft.data) === null || _a === void 0 ? void 0 : _a.results)) {
                const shouldRemove = options.target(action.data);
                draft.data.results = draft.data.results.filter((result) => !shouldRemove(result));
            }
        });
    };
}
function createUpdateCollectionReducer(options) {
    return function (state = options.state, action) {
        var _a;
        if (!((_a = state.data) === null || _a === void 0 ? void 0 : _a.results)) {
            return state;
        }
        return (0, immer_1.produce)(state, (draft) => {
            var _a;
            const update = options.update(action.data);
            (_a = draft.data) === null || _a === void 0 ? void 0 : _a.results.map(update);
        });
    };
}
function createTargetedUpdateCollectionReducer(options) {
    return function (state, action) {
        return (0, immer_1.produce)(state, (draft) => {
            var _a, _b, _c;
            if (!options.target || !((_a = draft === null || draft === void 0 ? void 0 : draft.data) === null || _a === void 0 ? void 0 : _a.results)) {
                return;
            }
            const update = options.update(action.data);
            const getTarget = options.target(action.data);
            const targetIndex = (_c = (_b = draft.data) === null || _b === void 0 ? void 0 : _b.results.findIndex(getTarget)) !== null && _c !== void 0 ? _c : -1;
            if (targetIndex !== -1) {
                draft.data.results[targetIndex] = update(draft.data.results[targetIndex]);
            }
        });
    };
}
function getCollectionSyncReducer(options) {
    let reducer;
    switch (options.syncVerb) {
        case Verbs_1.SyncVerb.Add:
            reducer = createAddCollectionReducer(options);
            break;
        case Verbs_1.SyncVerb.Remove:
            reducer = options.target ?
                createTargetedRemoveCollectionReducer(options) :
                createRemoveCollectionReducer(options);
            break;
        case Verbs_1.SyncVerb.Update:
            reducer = options.target ?
                createTargetedUpdateCollectionReducer(options) :
                createUpdateCollectionReducer(options);
            break;
        default:
            reducer = (state) => state;
    }
    return reducer;
}
function createCollectionSyncReducer(options) {
    const reducer = getCollectionSyncReducer(options);
    const type = (0, lib_1.createSyncActionTypeValue)({
        name: options.name,
        syncVerb: options.syncVerb
    });
    return function (state = options.state, action) {
        if (action.type !== type) {
            return state;
        }
        return reducer(state, action);
    };
}
function createSyncReducer(options) {
    const { transform } = options;
    const type = (0, lib_1.createSyncActionTypeValue)({
        name: options.name,
        syncVerb: options.syncVerb
    });
    return function (state = options.state, action) {
        return (0, immer_1.produce)(state, (draft) => {
            if (action.type === type && draft.data) {
                draft.data = (transform ? transform(action.data, draft.data) : action.data);
            }
        });
    };
}
//# sourceMappingURL=lib.js.map